<template>
    <!--<div class="row rounded border border-secondary">-->
    <div class="row">
        <div class="col-12 col-md-4">
            <div class="row">
                <div class="col-12">
                    {{ $t('product.order_code') }}:
                    {{ product.order_code }}
                </div>
                <div class="col-12">
                    {{ $t('product.serial_number') }}:
                    {{ product.sn }}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-1">
            {{ $t('product.quantity') }}:
            {{ product.quantity }}
        </div>
        <div class="col-12 col-md-5">
            <div class="row">
                <div class="col-12">
                    {{ $t('product.customer_price') }}:
                    {{ product.customer_price.toFixed(2) }}
                </div>
            </div>
        </div>
        <div class="col-12 col-md-2">
            {{ product.order_note }}
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hover: false,
        }
    },
    props: {
        product: {
            type: Object,
            default: () => { return {}; },
        },
    },
    methods: {
    }
}
</script>
<style scoped lang="scss">
@import '~@/_variables.scss';
</style>

